var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 1.6001C6.7343 1.6001 5.49692 1.97545 4.44445 2.67869C3.39198 3.38193 2.57167 4.38148 2.08727 5.55092C1.60287 6.72037 1.47613 8.0072 1.72307 9.24867C1.97002 10.4902 2.57956 11.6305 3.47462 12.5256C4.36967 13.4206 5.51004 14.0302 6.75152 14.2771C7.993 14.5241 9.27983 14.3973 10.4493 13.9129C11.6187 13.4285 12.6183 12.6082 13.3215 11.5557C14.0247 10.5033 14.4001 9.2659 14.4001 8.0001C14.3981 6.30333 13.7232 4.67662 12.5234 3.47682C11.3236 2.27703 9.69687 1.6021 8.0001 1.6001ZM10.1569 10.1569C10.0478 10.266 9.89983 10.3272 9.74555 10.3272C9.59128 10.3272 9.44331 10.266 9.33421 10.1569L7.58875 8.41144C7.47963 8.30235 7.41831 8.15439 7.41828 8.0001V4.50919C7.41828 4.35488 7.47958 4.20689 7.58869 4.09778C7.6978 3.98867 7.84579 3.92737 8.0001 3.92737C8.15441 3.92737 8.30239 3.98867 8.41151 4.09778C8.52062 4.20689 8.58192 4.35488 8.58192 4.50919V7.75922L10.1569 9.33421C10.266 9.44331 10.3272 9.59127 10.3272 9.74555C10.3272 9.89983 10.266 10.0478 10.1569 10.1569Z",
    fill: "#D9D1DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.e75dcc6b7081f31790b453c0d08da41d.svg";
export { ForwardRef as ReactComponent };